import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useMemo } from "react";
import Autoplay from "embla-carousel-autoplay";
import type { Slide } from "../../../interfaces/slide";
import "./carousel.scss";

export default function Carousel({ slides }: { slides: Slide[] }) {

  const autoplay = useMemo(
    () =>
      Autoplay({
        delay: 4000,
        stopOnInteraction: false,
        stopOnMouseEnter: false
      }),
    []
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      skipSnaps: false,
      containScroll: "trimSnaps"
    },
    [autoplay]
  );

  /* 🔥 FIX 1: reInit après mount */
  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.reInit();
  }, [emblaApi]);

  /* 🔥 FIX 2: reInit après changement slides */
  useEffect(() => {
    if (!emblaApi) return;

    const t = setTimeout(() => {
      emblaApi.reInit();
    }, 300);

    return () => clearTimeout(t);
  }, [emblaApi, slides]);

  /* 🔥 FIX 3: reInit quand images chargées */
  useEffect(() => {
    if (!emblaApi) return;

    const imgs = document.querySelectorAll("img");
    let loaded = 0;

    const onLoad = () => {
      loaded++;
      if (loaded >= imgs.length) {
        emblaApi.reInit();
      }
    };

    imgs.forEach((img) => {
      if (img.complete) onLoad();
      else img.addEventListener("load", onLoad);
    });

  }, [emblaApi]);

  if (!Array.isArray(slides)) return null;

  return (
    <div className="home-carousel-slider">
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">

          {slides.map((slide, i) => (
            <div className="embla__slide" key={i}>

              <picture>
                <source
                  srcSet={slide.media_mobile}
                  media="(max-width: 600px)"
                />
                <source
                  srcSet={slide.media_tablet}
                  media="(max-width: 1024px)"
                />

                <img
                  src={slide.media_desktop}
                  alt={slide.alt ?? ""}
                />
              </picture>

            </div>
          ))}

        </div>
      </div>
    </div>
  );
}